import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import useAppDispatch from 'hooks/useAppDispatch';
import { clearSearchOrders } from 'store/reducers/orderSlice';
import { clearReturnSlip as clearReturnSlipSet } from 'store/reducers/returnSlice';

const useGoHome = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    return useCallback(() => {
        navigate('/');
        dispatch(clearSearchOrders());
        dispatch(clearReturnSlipSet());
    }, [navigate, dispatch]);
};

export default useGoHome;
